import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHighfive = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .3,
		d: "M17.6016 5.64324C17.8003 4.92321 18.5469 4.49253 19.269 4.68158C19.9922 4.87029 20.4179 5.60746 20.2192 6.32742L18.3784 13.0206L18.6329 13.4614L20.3005 12.4986C20.9751 12.1091 21.8342 12.3332 22.2186 12.999C22.5505 13.574 22.4252 14.3065 21.9193 14.7486L20.4008 16.0761L15.4617 20M17.6016 5.64324L18.0796 3.9053C18.2783 3.18535 17.8526 2.44817 17.1294 2.25947C16.4069 2.07031 15.6599 2.50157 15.4617 3.2223L14.0324 8.4193M17.6016 5.64324L16.411 9.9724M9.26805 5.3342C9.46628 4.61346 10.2132 4.18221 10.9357 4.37137C11.6586 4.55995 12.0841 5.29633 11.8863 6.01587M11.8863 6.01587L11.886 6.0172M11.8863 6.01587L12.3647 4.27887C12.5629 3.55813 13.3099 3.12688 14.0324 3.31603C14.7557 3.50474 15.1813 4.24191 14.9826 4.96187",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.25147 8.93293C4.93111 8.25757 4.12061 7.96257 3.44194 8.27432C2.76241 8.58575 2.47127 9.38563 2.79194 10.0602L6.07759 16.9867L3.78347 16.1517C3.05146 15.8853 2.24438 16.2551 1.98144 16.9776C1.75436 17.6015 2.00504 18.3011 2.57999 18.6486L7.01215 21.3287C8.87217 22.4539 11.1697 22.5893 13.1344 21.6882C16.379 20.2011 17.7694 16.3811 16.2397 13.1564L13.4042 7.18038C13.0839 6.50501 12.2734 6.21002 11.5947 6.52176C10.9152 6.8332 10.624 7.63307 10.9447 8.3076M12.684 11.9757L10.1714 6.67881C9.85101 6.00344 9.04051 5.70845 8.36184 6.02019C7.68231 6.33162 7.39118 7.1315 7.71185 7.80602M10.2236 13.1026L6.93796 6.17608C6.6176 5.50071 5.80711 5.20572 5.12843 5.51746C4.4489 5.8289 4.15777 6.62878 4.47844 7.3033L7.76408 14.2298",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgHighfive);
export default ForwardRef;
